const list: Array<{value: boolean}> = [];

export function push(popup: { value: boolean }) {
    list.push(popup);
}

export function pop() {
    const popup = list.pop();
    if (popup) {
        popup.value = false;
    }
    return popup;
}
